import appConfig from "../config/appConfig"

export const saveTableState = (tablePrefix, key, value) => {
    if (appConfig.prefix && tablePrefix && key) {
        localStorage.setItem(`${appConfig.prefix}_${tablePrefix}_${key}`, value);
    }
}

export const getTableState = tablePrefix => {
    if (appConfig.prefix && tablePrefix) {
        const state = {};
        for (const key in localStorage) {
            if (key.startsWith(`${appConfig.prefix}_${tablePrefix}`)) {
                const split = key.split('_');
                const stateKey = split?.[split.length - 1] ?? null;
                let value = localStorage.getItem(key);
                if (value) {
                    if (!isNaN(value)) {
                        value = Number(value);
                    }
                    state[stateKey] = value;
                }
            }
        }
        return state;
    }
    return {};
}

export const getTableStateByKey = (tablePrefix, key) => {
    return localStorage.getItem(`${appConfig.prefix}_${tablePrefix}_${key}`);
}

export const saveState = (key, value) => {
    localStorage.setItem(`${appConfig.prefix}_${key}`, value);
}

export const loadState = key => {
    return localStorage.getItem(`${appConfig.prefix}_${key}`);
}

/**
 * Merchant солих үед browser-т үлдсэн БҮХ локал датаг цэвэрлэнэ.
 *
 * Хагас бөглөсөн draft (sessionStorage — захиалга, бараа, багц бараа),
 * хүснэгтийн хуудаслалт/баганын тохиргоо (localStorage) зэрэг нь merchant-аас
 * хамааралтай мэдээлэл агуулдаг. `changeMerchant` нь нэг таб дотор
 * `window.location.href`-ээр дахин уншуулдаг тул эдгээр нь өөрөө устдаггүй,
 * улмаар өмнөх merchant-ийн бараа/агуулах шинэ merchant дээр хадаад үлддэг байв.
 *
 * ЧУХАЛ: zustand-ийн persist (`merchant-web`) энд хамт устана. Тиймээс үүнийг
 * шинэ merchant-ийн token-ыг `set` хийхээс ӨМНӨ дуудна — set хиймэгц persist
 * шинэ утгаа буцаан бичих тул нэвтрэлт тасрахгүй
 * (store/createUserSlice.js → changeMerchant).
 */
export const clearBrowserStorage = () => {
    try {
        localStorage.clear();
        sessionStorage.clear();
    } catch (error) {
        // Private mode зэрэгт хандалт хаагдсан ч merchant солих урсгалыг таслахгүй
        console.error("clearBrowserStorage: ", error);
    }
};

export const savePaginationState = (prefix, params = {}) => {
    if ("page" in params) saveTableState(prefix, "page", params.page);
    if ("limit" in params) saveTableState(prefix, "limit", params.limit);
    if ("pageSize" in params) saveTableState(prefix, "pageSize", params.pageSize);
    if ("totalDocs" in params) saveTableState(prefix, "totalDocs", params.totalDocs);
};
  